// @flow
import React from 'react';
import styled from 'styled-components';

/*
  The `FeatureNotEnabledView` is a 404-type page for displaying a warning message
  when a user tries accessing a page which they do not have permission to view.
*/

const Container = styled.div`
  padding: 2rem;
`;

export const FeatureVerificationComponent = () => (
  <Container>
    <h4>Verifying Access</h4>
    <p>Verifying your account has access to the requested feature.</p>
  </Container>
);

export const AccessDeniedComponent = () => (
  <Container>
    <h4>Access Denied</h4>
    <p>
      The feature you have requested to access is not enabled for your account.
      Please contact your account administrator.
    </p>
  </Container>
);

export const FeatureNotEnabledView = () => {
  return <AccessDeniedComponent />;
};

export default FeatureNotEnabledView;



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/containers/features/FeatureNotEnabledView.js